// This file will used to communicate with Sanity.io
import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "222wxajt",
  dataset: "production",
});
